/**
 * Returns the cache-busted src for a cross-origin image, or null when the image needs no
 * busting (same-origin, or a data:/blob: URI). See captureElement in capture_utils.ts.
 */
export const crossOriginBustedSrc = (src, pageOrigin) => {
  if (!src || !/^https?:/i.test(src)) return null;
  if (new URL(src, pageOrigin).origin === pageOrigin) return null;
  return src + (src.includes("?") ? "&" : "?") + "sgcb=1";
};
